module.exports = __webpack_public_path__ + "static/img/aquaman2_en.174581a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman2_en.png
// module id = Mi2T
// module chunks = 1